exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n\r\n/*#addUser{\r\n\theight:35%;\r\n}*/\r\n.adduser-modal{\r\n\t/*width:80%;\r\n\tpadding:2px;\r\n\tz-index: 10501;*/\r\n\theight: 85% !important;\r\n}\r\n\r\n.access_time .panel-body p {\r\n\tmargin: 0;\r\n}\r\n.access_time .panel-body {\r\n\tmin-height: 170px;\r\n}\r\n.access_time .panel {\r\n\twidth: 95%;\r\n}\r\n\r\n.access_time .time-selector {\r\n\twidth: 41%;\r\n\tfloat: left;\r\n\tfont-size: 13px;\r\n\tpadding: 6px 10px !important;\r\n}\r\nhr{\r\n  height: 1px;\r\n  background-color: #A9A9A9;\r\n}\r\nh6{\r\n  font-weight: bold;\r\n  color: #007b85;\r\n}\r\n::ng-deep .mat-progress-bar-fill::after {\r\n    background-color: #F15D22;\r\n}\r\n\r\n::ng-deep .mat-progress-bar-buffer {\r\n    background: #E4E8EB;\r\n}\r\n\r\n::ng-deep .mat-progress-bar {\r\n    border-radius: 2px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-users/manage-users.component.css
// module id = 461
// module chunks = 1